module.exports = __webpack_public_path__ + "static/media/mob-cricket-banner.fdef51a6.webp";